<label>
    Name:
    <input type="text" [formControl]="name">
</label>
<p>
    Value: {{ name.value }}
</p>
<p>
    <button (click)="updateName()">Update Name</button>
</p>